import { HideAllLinesCommand } from "slotworks/commands/lines/hide-all-lines-command";
import { ShowLinesCommand } from "slotworks/commands/lines/show-lines-command";
import Components from "slotworks/components/components";
import AllWinsMediator from "slotworks/mediators/all-wins-mediator";
import AutoplayModel from "slotworks/model/autoplay-model";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import State from "slotworks/state-machine/states/state";
import { parallel } from "slotworks/utils/race-utils";
import Timer from "slotworks/utils/timer";
import Regulation from "slotworks/integration/revolver/regulations/regulation";

export default class ShowWinLines extends State {

    public static MULTILINE_ONLY: boolean = false;
    public static WIN_TICK_TIME: number = 750;
    public static END_DELAY: number = 0;

    private onDisplayComplete: Function;

    public onEnter() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const results = record.results;
        const lines = [];

        const totalWin = GameState.getCurrentGame().totalCreditsWon;

        for (const result of results) {
            if (result instanceof LineResult) {
                lines.push(result.line);
            }
        }

        if (this.hasOneLine(lines) && this.onlyShowOnMultipleWinLines(record)) {
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 0);
            Regulation.updateNetPosition(GameState.getNetPosition());
            this.complete();
            return;
        }

        ShowLinesCommand(lines).execute();

        const raceFuncs = [];

        if (this.allWinsAreSameSymbol(record) && this.isAutospinsOrFreespins(record)) {
            const result = results[0] as LineResult;
            if (result) {
                raceFuncs.push(() => Components.celebrateWin.singleTotalWin(record.creditsWon, result));
            }
        } else {
            raceFuncs.push(() => Components.celebrateWin.totalWin(record.creditsWon));
        }

        const allWinsMediator = new AllWinsMediator();
        raceFuncs.push(() => allWinsMediator.start());

        this.onDisplayComplete = () => {
            this.onDisplayComplete = null;
            allWinsMediator.end();
            HideAllLinesCommand().execute();
            Components.celebrateWin.hide();
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, ShowWinLines.WIN_TICK_TIME);
            Regulation.updateNetPosition(GameState.getNetPosition());
        };

        parallel(raceFuncs).then(() => {
            Timer.setTimeout(() => {
                if (this.onDisplayComplete) {
                    this.onDisplayComplete();
                    this.complete();
                }
            }, ShowWinLines.END_DELAY);
        });
    }

    public onSkip() {
        if (this.onDisplayComplete) {
            this.onDisplayComplete();
        }
        this.skip();
    }

    private allWinsAreSameSymbol(record: Record) {
        const symbolTypes: string[] = [];
        for (const result of record.results) {
            if (result instanceof LineResult) {
                symbolTypes.push(result.symbolType);
            }
        }

        return symbolTypes.every((v) => v === symbolTypes[0]);
    }

    private hasOneLine(lines: number[]) {
        return lines.length <= 1;
    }

    private isAutospinsOrFreespins(record: Record) {
        return (record instanceof FreespinRecord) || AutoplayModel.isAutoPlaying();
    }

    private onlyShowOnMultipleWinLines(record: Record) {
        return !this.isAutospinsOrFreespins(record) && ShowWinLines.MULTILINE_ONLY;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/show-win-lines.ts